import {isSelectiveAiDomains} from 'common/HelperFunctions'
import {FC, HTMLAttributes} from 'react'

import SelectiveAiLoadingLogo from './SelectiveAiLoadingLogo'

interface Props extends HTMLAttributes<HTMLElement> {
  type?: 'border' | 'grow'
  size?: 'sm' | 'lg' | undefined
  color?:
    | 'primary'
    | 'secondary'
    | 'warning'
    | 'info'
    | 'success'
    | 'danger'
    | 'dark'
    | 'light'
    | undefined
  className?: string
}

const Spinner: FC<Props> = ({type = 'grow', size, color, className = '', ...otherProp}) => {
  // For isSelectiveAiDomains: button spinners (size='sm' or type='border')
  // should render as a native border spinner instead of the loading logo.
  const isButtonSpinner = size === 'sm' || type === 'border'
  const effectiveType = isSelectiveAiDomains() && isButtonSpinner ? 'border' : type

  if (isSelectiveAiDomains() && !isButtonSpinner) {
    const logoSize = size === 'lg' ? 96 : 244

    return (
      <SelectiveAiLoadingLogo
        size={logoSize}
        alt='Loading...'
        className={className}
        {...(otherProp as HTMLAttributes<HTMLImageElement>)}
      />
    )
  }

  return (
    <span
      className={`spinner-${effectiveType} ${color ? `text-${color}` : ''} ${
        size ? `spinner-${effectiveType}-${size}` : ''
      } ${className}`}
      role='status'
      {...otherProp}
    >
      <span className='visually-hidden'>Loading...</span>
    </span>
  )
}

export default Spinner
